var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramOnline40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 8.000000)",
    fillRule: "nonzero",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L16,8 L16,16 C16,20.418278 12.5282383,24 8.24605925,24 L7.75394075,24 C3.4715575,24 0,20.4192494 0,16 L0,8 Z",
    id: "Mouse",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L8,0 L8,0 L8,8 L0,8 L0,4 C0,1.790861 1.790861,0 4,0 Z",
    id: "Focus",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L16,0 L16,0 L16,8 L8,8 L8,4 C8,1.790861 9.790861,0 12,0 Z",
    id: "Right-button",
    fill: "#FFFFFF",
    transform: "translate(12.000000, 4.000000) scale(-1, 1) translate(-12.000000, -4.000000) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramOnline40);
export default __webpack_public_path__ + "static/media/pictogramOnline40.fa27b1c59b54d63c782fb819a50b8c77.svg";
export { ForwardRef as ReactComponent };